<template>
  <div
    :class="['item-wrapper border d-flex align-items-center', `-${list_view}`, { 'flex-column': list_view === 'gallery' }, cssClass]">
    <div v-if="list_view === 'gallery'" class="text-right d-inline-flex align-items-center align-self-end mb-3">
      <div :class="['status-dot mr-2', `-${campaign.status.toLowerCase()}`]"></div>
      <span :class="['text-capitalize punch-card-status', `-${campaign.status.toLowerCase()}`]">{{ campaign.status
        }}</span>
    </div>
    <div
      :class="['img-wrapper d-inline-flex align-items-center justify-content-center overflow-hidden flex-shrink-0', { 'mr-4': list_view === 'deck', 'mb-3': list_view === 'gallery', 'bg-light': !campaign.image }]">
      <img :src="campaign.image" :alt="campaign.name" class="img-fluid" v-if="campaign.image">
    </div>
    <div
      :class="['campaign-details flex-grow-1', { 'd-flex flex-column justify-content-between w-100 px-3': list_view === 'gallery' }]">
      <div class="d-inline-flex justify-content-between w-100">
        <div :class="[{ 'w-75': list_view === 'deck', 'text-center w-100': list_view === 'gallery' }]">
          <p class="campaign-name font-weight-bold mb-0">{{ campaign.name }}</p>
          <p class="campaign-description mb-0">{{ campaign.description }}</p>
        </div>
        <div v-if="list_view === 'deck'" class="text-right d-inline-flex align-items-center align-self-start">
          <div :class="['status-dot mr-2', `-${campaign.status.toLowerCase()}`]"></div>
          <span :class="['text-capitalize punch-card-status', `-${campaign.status.toLowerCase()}`]">{{ campaign.status
          }}</span>
        </div>
      </div>
      <div
        :class="['d-inline-flex w-100', { 'align-items-center justify-content-between': list_view === 'deck', 'flex-column align-items-start mt-4': list_view === 'gallery' }]">
        <div :class="[{ 'w-75': list_view === 'deck', 'mb-3 d-inline-flex flex-column': list_view === 'gallery' }]">
          <span :class="['members', { 'mr-4': list_view === 'deck', 'mb-2': list_view === 'gallery' }]">
            <img src="~@/assets/images/icons/punch-card/members.svg" alt="Campaign Members">
            {{ thousandsSeparator(campaign.participants) }}
          </span>
          <span class="duration-display">
            <img src="~@/assets/images/icons/punch-card/duration.svg" alt="Campaign Duration">
            {{
              `${campaign.date_start && campaign.date_end ?
                durationDisplay(campaign.date_start, campaign.date_end, "dateOnly") :
                "Lifetime"}`
            }}
          </span>
        </div>
        <div
          :class="['text-right d-inline-flex align-items-center', { 'w-100 justify-content-end': list_view === 'gallery' }]">
          <ActionButtons :uuid="campaign.uuid" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { thousandsSeparator, durationDisplay } from "./punch.card.utilities";
import ActionButtons from "./PunchCardActionButtons.vue";

export default {
  components: { ActionButtons },
  props: ["campaign", "cssClass"],
  computed: {
    ...mapState("punchCard", ["list_view"])
  },
  data() {
    return {
      thousandsSeparator,
      durationDisplay
    }
  }
}
</script>

<style lang="scss" scoped>
.item-wrapper {
  border-color: #D8DCDE !important;
  border-radius: 10px;

  .img-wrapper {
    width: 112px;
    height: 92px;

    &>img {
      object-fit: fill;
    }
  }

  &.-deck {
    padding: 36px 35px;
  }

  &.-gallery {
    padding: 17px 14px;
  }
}

.campaign-name {
  font-size: 20px;
}

.campaign-description {
  font-size: 16px;
  color: #87929D;
}

@import "~@/assets/scss/punch-card/_status.scss";
</style>